import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FileDropperComponent } from './file-dropper.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
    ],
    exports: [FileDropperComponent],
    declarations: [FileDropperComponent],
    providers: [],
})
export class FileDropperModule { }
